import UpworkLogo from "./../upwork-1.svg";
import FreelancerLogo from "./../freelancer-1.svg";
import image from "./../image.jpeg";

export const NOTIFICATION_TYPES = Object.freeze({
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
  ERROR: "error",
});

export const PAYMENT_STATUS = Object.freeze({
  PAID: "Paid",
  PARTIAL_PAID: "Partially Paid",
});

export const profileData = Object.freeze({
  skills: [
    {
      label: "Language & Framework",
      list: [
        "C",
        "C++",
        {
          text: "C# (with .Net)",
          details: [
            "Basic topics of C# .Net",
            "Work with both web and desktop application",
            "Implement authentication and strong authorization in backend",
            "Write efficient mvc project's code following proper conventions, onion architecture, using middleware, linq and others",
            "Work with Soap client to generate codes",
            "Work with RDLC to generate reports",
            "Work with creating pdf/doc files and storing in AWS",
            "Work with sql databases in C# applications",
            "Work with API project in .Net",
            "Work with managing configuration settings of application",
            "Work with azure for application deployments",
          ],
        },
        "Java",
        "Javafx",
        "Html",
        "Css(with Scss)",
        "Javascript",
        {
          text: "React",
          details: [
            "Basic Topics of React",
            "Implement interactive, user-friendly frontend applications",
            "Create and deploy components library and use that in applications",
            "Implement efficient, performant application by organizing codebase and managing states, redux stores properly",
            "Work with Prime React, React Bootstrap, Material UI for maintaining awesome UI",
            "Work with Electron and deploy desktop version of react application",
            "Integrate drag-drop features with several complex components",
            "Work with drawing tools",
            "Integrate document file generation",
          ],
        },
        {
          text: "Node",
          details: [
            "Implement socket programming for a chat application",
            "Work with mongodb for several applicatoins",
          ],
        },
        "Next",
      ],
    },
    {
      label: "",
      list: [
        {
          text: "Native Android",
          details: [
            "Basic topics of developing android applications using Java",
            "Implement application with responsive UI",
            "Implement rendering efficient, performant list",
            "Implement realtime chat application",
            "Implement drawing application",
            "Work with multi-threading efficiently",
            "Implement application which needs authentication and authorization",
            "Work with android local database to make the application efficient",
            "Work with screensharing application",
            "Work with eyeblink detection for camera app using ai library",
            "Implement dragging-dropping features in applications",
          ],
        },
        {
          text: "Swift (with SwiftUI)",
          details: [
            "Basic topics of developing ios applications using Swift and SwiftUI",
            "Implement application with responsive UI which are supported in iphone, ipad, mac concurrently",
          ],
        },
        {
          text: "SQL",
          details: [
            "Basic topics of sql",
            "Work with trigger, stored procedure, function, complex queries, CTE",
          ],
        },
        {
          text: "Vue",
          details: [
            "Basic topics of Vue",
            "Implement interactive, user-friendly UI using Vuetify",
            "Maintain quality code using proper stores and following other best approaches",
            "Implement realtime chat application using Vue in frontend",
            "Develop and maintain features of applications used for managing official works",
          ],
        },
        "Jquery",
        {
          text: "Django Rest Framework",
          details: [
            "Basic topics of DRF",
            "Implement efficient backend applications",
            "Implement database queries using SqlAlchemy",
            "Use alembic for databas migrationis",
            "Implement authentication and resource based authorization",
            "Implement socket for realtime chat application",
          ],
        },
        {
          text: "Python",
          details: [
            "Basic topics of python",
            "Work with image and data processing softwares several libraries like numpy, pandas, PIL, openCV and several others",
            "Write python scripts which generate codes for codebase migrations",
            "Write and use Pytest codes",
          ],
        },
        {
          text: "PHP (with Laravel)",
          details: [
            "Basic topics of PHP",
            "Basic topics of Laravel",
            "Implement application with laravel backend and blade for frontend",
            "Implement backend application with proper authentication and authorization",
            "Integrate vue files with laravel server-side application",
            "Develop and maintain features of applications used for managing official works",
          ],
        },
      ],
    },
    {
      label: "Database",
      list: [
        "Microsoft SQL Server",
        "Postgres",
        "Sqlite",
        "MongoDB (with mongoose)",
        "Firebase",
      ],
    },
    {
      label: "Hosting & Storage",
      list: ["AWS", "Firebase", "Heroku"],
    },
    {
      label: "Other",
      list: ["Figma Design", "Illustrator"],
    },
  ],
  experience: [
    {
      web_link: "https://www.enosisbd.com",
      heading: "Enosis Solution",
      time: "Jun 2022 - Now",
      postings: [
        {
          title: "Senior Software Development Engineer",
          description: `
          <ul type='disc'>
            <li>Analyze requirements, design development plans, and provide estimation</li>
            <li>Design and develop new features, modify existing features, resolve existing bugs, and update business logic with analyzing side effects</li>
            <li>Assess, and guide junior resources, maintain clean codes following the best approach</li>
            <li>Implement Interactive, fully responsive web UI supporting mobile and desktop devices and deploy components packages with React, SCSS, and Vue</li>
            <li>Build and deploy the desktop version of web apps with Electron</li>
            <li>Write test code using Pytest</li>
            <li>Implement backend with complex business logic using Django Rest Framework with swagger documentation and strong authentication, authorization system</li>
            <li>Design and update database with SqlAlchemy, Alembic</li>
            <li>Take professional training on Vue, PHP with Laravel and working in a client project from february, 2025</li>
            <li>Share work update and discuss about the requirements/blockers in daily scrum call with foreign client, guide teammates, review junior engineer's work</li>
            <li>Review existing laravel-vue application's security and redesigned the access right for various roles in backend</li>
            <li>Implement multi-tenancy in existing application with solving tons of challenges and successfully completed it</li>
          </ul>
          `,
          time: "Jun 2024 - Now",
        },
        {
          title: "Software Development Engineer",
          description: `
          <ul type='disc'>
            <li>Analyze requirements, develop new features, modify existing features, resolve existing bugs, and update business logic with analyzing side effects</li>
            <li>Migrate existing projects from one tech stack to another (mainly from vb to C# .net)</li>
            <li>Make documentation regarding technology, codebase, and work approach, application features</li>
            <li>Perform testing and make proper acceptance criteria for the QA team by identifying corner cases</li>
            <li>Work on .Net applications maintaining strong security, authorization, and validation checking in the backend</li>
            <li>Maintain proper usage of Linq, Onion architecture, Dependency injection, Disposal of Service, Routing,  Async Thread, MVC framework, Entity framework</li>
            <li>Perform working with reading and updating configuration variables from the local and Azure environment</li>
            <li>Implement reports with RDLC</li>
            <li>Work with AWS storage to keep and use files for C# applications</li>
            <li>Work with SQL server for database and Dapper to connect the backend with the database</li>
            <li>Implement challenging, interactive, efficient, user-friendly UI with JQuery and Javascript</li>
            <li>Generate automotive tools/scripts that help migrate existing codebase automatically and update feature</li>
            <li>Generate PDF/doc files using several .Net libraries</li>
            <li>Take professional training on React, Python with Django Rest Framework</li>
          </ul>`,
          time: "Jun 2022 - May 2024",
        },
      ],
    },
    {
      web_link: "https://www.freelancer.com/",
      heading: "Freelancer",
      title: "Web & Mobile App developer",
      description:
        "I have started working here from 2020. I often work here when i am free. I have done many mini-projects here, some projects too. I occasionally work in freelancer, upwork when I get free time and specially before my current job.\n" +
        "You can check my works & rating here:<br><br>\n",
      time: "Feb 2020 - Now",
      links: [
        {
          name: "Freelancer",
          img: FreelancerLogo,
          url: "https://www.freelancer.com/u/Apurb0karNel",
          note: "The id name is different because whenever I created the account, my passport wasn't ready and I had to work using my father's passport.",
        },
        {
          name: "Upwork",
          img: UpworkLogo,
          url: "https://www.upwork.com/freelancers/~01b2061c8cf2dc846e",
        },
      ],
    },
    {
      web_link: "/",
      heading: "Research Experience",
      title: "",
      description:
        "I have worked with several research teams from university life. My undergraduate thesis topic was 'Study on technology for guiding visually impaired persons in the context of dhaka city' and I have worked with a research company with this topic via my supervisor. Here we researched about existing technologies and their usage in the context of Dhaka city.",
      time: "Feb 2021 - 2022",
    },
  ],
  education: [
    {
      web_link: "https://www.buet.ac.bd",
      heading: "Bangladesh Unitversity of Engineering & Technology",
      title: "CSE Graduate",
      description:
        "After a competetive admission war across the whole country I have been admitted to BUET <span class='text-danger'>(the most prestigious university of my country)</span>. I have completed my B.Sc. in computer science here. I have done a lot of offlines and projects during these periods. These sophisticated works made me perfect for industrial works. I have learnt a lot of things(both academic and non-academic) in my university life. I obtained better grades in software development related courses here. I wish i will be able to use these knowledge well.",
      time: "Feb 2017 - May 2023",
    },
  ],
  courses: [
    "Structured Programming Language",
    "Object Oriented Programming",
    "Data structure and Algorithm",
    "Numerical Analysis",
    "Database Management System",
    "Theory of Computation",
    "Compiler",
    "Computer Architecture",
    "Microprossesor & Assembly Language",
    "Design Pattern & ISD",
    "Operting System",
    "Networking",
    "Software Development",
    "Artificial Intelligent",
    "High Performance Database System",
    "Computer Security",
    "Pattern Recognition",
    "Machine Learning",
  ],
});

export const menuData = Object.freeze([
  {
    key: "whoAmI",
    value: "Who am I!",
  },
  {
    key: "myExperience",
    value: "My Experience",
  },
  {
    key: "freelanceShowcase",
    value: "Showcase",
  },
  {
    key: "myEducation",
    value: "My Education",
  },
  {
    key: "mySkills",
    value: "My Skills",
  },
  {
    key: "learntCSCourses",
    value: "Undergraduate CS courses",
  },
  {
    key: "getInTouch",
    value: "Get In Touch!",
  },
]);

export const intrductoryData = Object.freeze({
  name: "Apurba Prasad Karmaker",
  designation: "Senior Software Engineer (Full Stack)",
  location: "Dhaka, Bangladesh",
  email1: "apurba.karmaker.buet@gmail.com",
  email2: "1605096@ugrad.cse.buet.ac.bd",
  image: image,
  description:
    "Hi, I am a computer science graduate from BUET. I have learnt fundamentals of software development and computer science well. I have experiences in working with multiple programming languages, frameworks, databases, platforms, ml, analytical systems etc. I have also experience of solving lot of programming contest questions. \
              My preferred operating system is macos but i am completely fine with linux/windows. My preferred code-sharing platform is github and i am used to both command prompts and UI (source tree). I want to build career as a good Software Engineer primarily but I may also have interest slightly in pursuing phd degree later and involve my career in research fields if i get opportunity. My positive sides are having positive \
              mindset, perseverance, dedication, honesty. I always learn from mistakes and try to upgrade myself. \
              I believe that time is a wealth if it can be properly utilized. So i try to make a best use of it. \
              <br>&nbsp;&nbsp;<space><space>However, If you need apps in following criteria, then you can contact me for your project:\
              <br>&nbsp;&nbsp;<space><space>    - Do you need an android app supporting in android devices as much as possible?\
              <br>&nbsp;&nbsp;<space><space>    - Do you need an apple app supporting in ios devices as much as possible?\
              <br>&nbsp;&nbsp;<space><space>    - Do you need desktop app supporting in windows, linux, mac?\
              <br>&nbsp;&nbsp;<space><space>    - Do you need a responsive website with proper hosting plan?\
              <br>&nbsp;&nbsp;<space><space>    - Do you need fully synced mobile and web application with real-time data update like chatbot?\
              <br>&nbsp;&nbsp;<space><space>    - Do you need image processing softwares?\
              <br>&nbsp;&nbsp;<space><space>    - <b>Do you want to recruit me in your company?</b>\
              <br>&nbsp;&nbsp;<space><space>\
              <br>&nbsp;&nbsp;Please have look all over the page to get more details.",
});

export const uiText = Object.freeze({
  message:
    "Send me your message about job or projects. Share your contact information so that i can reach to you. If i delay to reach, then please email me. Thank you!",
  downloadLabel: "Download my CV",
});

const showcaseProjects = [
  {
    heading: "IOS",
    projects: [
      {
        heading: "Languin",
        description:
          "This app is for practicing vocabulary with pronunciation for any languages. User can select source and destination language and practice translation as long as he wants. You can find ios version in app store: https://apps.apple.com/us/app/languin/id6450793438. For playstore version please check android section.",
        video_link: "O1Lug5Ey1Bs",
        payment: PAYMENT_STATUS.PAID,
      },
      {
        heading: "Daily Horoscope",
        description:
          "This app displays horoscope for all signs in all language for daily basis. Additionally, user can practice quiz related to horoscope and others. For playstore version please check android section.",
        video_link: "HAhQVqBG0kE",
        payment: PAYMENT_STATUS.PAID,
      },
    ],
  },
  {
    heading: "ANDROID",
    projects: [
      {
        heading: "INCNT",
        description:
          "This is a survey app where users provide answers of some questions through android application and these are stored in database for future processing.",
        video_link: "ECav_xiXd_Y",
        payment: PAYMENT_STATUS.PAID,
      },
      {
        heading: "Live meeting",
        description:
          "I developed a rough app which can manage video-audio call system,screensharing etc.",
        video_link: "FoiLA2SVHVg",
      },
      {
        heading: "WhitePad android",
        description:
          "You can find it here:https://play.google.com/store/apps/details?id=virtual.white.pad \nThis is a drawing application tool for managing large space in  tiny phone screen. Users can draw/write something on the screen, scale it down  and thus get rid of facing difficulties while drawing something with tiny size. This app can be helpful for using whiteboard in tiny phone. This application has both android and web version.",
        video_link: "i1ga7a-9Txc",
      },
      {
        heading: "Teenshield",
        description:
          "This app is for maintaining parental control over child’s phone. There are two separate application for child and parent. Here parents can set some youtube videos for child app and child can only see these videos. Parent can lock child app and see history for child from the app for parent.",
        video_link: "QOnVfDO8JRw",
        payment: PAYMENT_STATUS.PARTIAL_PAID,
      },
      {
        heading: "ECB mart",
        description:
          "This is an ecommerce app with nodejs backend. User can order their products via online.",
        video_link: "CiO-EN5fQTc",
        payment: PAYMENT_STATUS.PAID,
      },
      {
        heading: "BoTeacher",
        description:
          "This is a teacher-student live platform. Here student can ask questions and then teachers solve it. Student can also get counselling from teachers. Students provide rating on the solutions. Students can gossip among themselves. Teachers get payment according to the ratings of their solution.",
        video_link: "DTeHjLqHeSY",
        payment: PAYMENT_STATUS.PARTIAL_PAID,
      },
      {
        heading: "Vision Excercise",
        description:
          "You can find it here:https://play.google.com/store/apps/details?id=vision.exercise.eye \nOne of my freelancing projects. Here user can practice their eye power by determining some symbols. Their performance can be estimated using the delayed time.",
        video_link: "z4Hi2qRrkps",
        payment: PAYMENT_STATUS.PAID,
      },
      {
        heading: "Languin",
        description:
          "This app is for practicing vocabulary with pronunciation for any languages. User can select source and destination language and practice translation as long as he wants. Android version is available at: https://play.google.com/store/apps/details?id=app.data.dataguin. For appstore version please check ios section.",
        video_link: "O1Lug5Ey1Bs",
        payment: PAYMENT_STATUS.PAID,
      },
      {
        heading: "Daily Horoscope",
        description:
          "This app displays horoscope for all signs in all language for daily basis. Additionally, user can practice quiz related to horoscope and others. Playstore link: https://play.google.com/store/apps/details?id=daily.horoscope.dahmurat",
        video_link: "HAhQVqBG0kE",
        payment: PAYMENT_STATUS.PAID,
      },
      {
        heading: "Live English",
        description:
          "You can find it here: https://play.google.com/store/apps/details?id=app.english.learning \nThis application was developed for an English tutor. Here daily tasks and and practice questions were provided by the tutor and students solve these.",
        video_link: "",
        payment: PAYMENT_STATUS.PAID,
      },
      {
        heading: "Complete Mental Health Solution",
        description:
          "A online based complete Mental health project. Here you can test your mental condition,consult with professionals even share your questions via chat with them or even consult with bot. This is our term project of SD lab. I developed user app and my partner developed the admin panel. It's backend is firebase.",
        video_link: "6R_Woq7meUA",
        isAssignment: true,
      },
      {
        heading: "GRE Calculator",
        description:
          "This is basic calculator app. All the functionalities and the UI is exactly same as the calculator for official GRE exam. Play Store link: https://play.google.com/store/apps/details?id=prep.gre.grecalculator",
        video_link: "",
        payment: PAYMENT_STATUS.PAID,
      },
      // {
      //   heading: "Others",
      //   description:
      //     "Also i have developed admin panels of some app,some pet mini-projects ie screenrecorder,birthday reminder,sms sender,chat platform,app locker and more.",
      //   video_link: "",
      // },
    ],
  },
  {
    heading: "C/C++",
    projects: [
      {
        heading: "WW3 Game",
        video_link: "GJF6gnjKvT4",
        description:
          "This just a 2d war game. Here player need to survive by avoiding bullets from opponent. He also need to kill enemies to earn point.",
      },
      {
        heading: "Hunting",
        description:
          "Player has to throw an arrow and hunt food. I was a bit interested about implementing rotating motion and linear motion of a dispatched arrow. Then i implemented it passionately.",
        video_link: "XE511s0FWB4",
      },
      {
        heading: "DX ball",
        video_link: "grcY7SGIlgo",
        description:
          "I was a bit interested to build dxball type game from my early ages. This game is almost same as common dxball games. I made it with passion and challenged me to build an app within one day.",
      },
      {
        heading: "Snake Ladder",
        description: "This is exactly same as typical snakeladder game.",
        video_link: "T_lH4nFnBl4",
      },
      // {
      //   heading: "Others",
      //   description:
      //     "Also i have developed some other pet mini-projects and completed a lot of assignments with c/c++ and i-graphics.",
      //   video_link: "",
      // },
    ],
  },
  {
    heading: "JAVA",
    projects: [
      {
        heading: "Snake Ladder",
        description: "This one is exactly like typical snake ladder game.",
        video_link: "1LXipV_fOes",
      },
      {
        heading: "Todolist",
        description:
          "This app is for managing daily routine/daily tasks. Here user can add/remove specific tasks and explore them altogether. User can add task daily basis. They can also use calendar which remains within the app.",
        video_link: "pUIBlgJoBvQ",
        payment: PAYMENT_STATUS.PAID,
      },
      {
        heading: "Algorithm Simulator",
        description:
          "This was our term project of java course. This project helps user to visualize several basic algorithms of cs. I along with my project partner developed this. The project was praised by our supervisor.",
        video_link: "o6zIfLUGbNQ",
        isAssignment: true,
      },
      {
        heading: "Unmochon",
        description:
          "This app is for preventing sexual harassment of women. This app take screenshot of messenger and send to our server for further analysis. This was a paid project. I along with a senior brother from buet cse'15 developed it.",
        video_link: "Row-gh_mXe8",
        payment: PAYMENT_STATUS.PAID,
      },
      {
        heading: "3D motion simulator",
        description:
          "I was too much passionate for 3d motion when i was leaning java. So from passion,i tried to make a game like this. There player moves with a car. He needs to survive by avoiding other cars.",
        video_link: "znSPKTGOZOQ",
      },
      // {
      //   heading: "Others",
      //   description:
      //     "Also i have developed some other pet mini-projects and completed a lot of assignments with java and javafx.",
      //   video_link: "",
      // },
    ],
  },
  {
    heading: "C#",
    projects: [
      {
        heading: "GRE Calculator",
        description:
          "This is basic calculator app. All the functionalities and the UI is exactly same as the calculator for official GRE exam.",
        video_link: "qom6XcplyT4",
        payment: PAYMENT_STATUS.PAID,
      },
    ],
  },
  {
    heading: "MicroController",
    projects: [
      {
        heading: "Path Finder",
        description:
          "We have tried to implement a Path Finder Robot that moves towards a specified target. The bot moves left or right whenever there an obstacle in front of it and reroutes itself to move towards its initial target. We used atmega-32,LCD display,us sonar sensor,chesis,motor driver,wheel-encoder,gyroscope etc.",
        video_link: "gOQEdRyjoBk",
        isAssignment: true,
      },
    ],
  },
  {
    heading: "REACTJS",
    projects: [
      {
        heading: "Whitepad Web",
        description:
          "You can find it here: https://whitepad-web.firebaseapp.com/\n. This is a drawing application tool for managing large space in  tiny phone screen. Users can draw/write something on the screen, scale it down  and thus get rid of facing difficulties while drawing something with tiny size. This app can be helpful for using whiteboard in tiny phone.",
        video_link: "kx1nhOr0P9M",
      },
      {
        heading: "Boighor",
        description:
          "This is a platform for providing online version of several books to the customers. Customers can study the pdf books, rate, comment. There is also admin panel and books are maintained by the admin panel.",
        video_link: "Fhzcc_8-Gas",
      },
      {
        heading: "Incnt Tutorial",
        description:
          "This is a tutorial site for INCNT users. Here user has to submit some information, watch videos and submit feedback. This site is completely mobile friendly and it displays the contents according to window size. This site is in production but link is prohibited to share by client. Also there is another website which is the admin dashboard for this application.",
        video_link: "ki7ALG3RjbQ",
        payment: PAYMENT_STATUS.PAID,
      },
    ],
  },
  {
    heading: "React-Native",
    projects: [
      {
        heading: "Languin",
        description:
          "This app is for practicing vocabulary with pronunciation for any languages. User can select source and destination language and practice translation as long as he wants. Firstly, I developed this paid app with react-native. But later I was facing issue with admob so migrated to native languages and redeveloped.",
        video_link: "O1Lug5Ey1Bs",
        payment: PAYMENT_STATUS.PAID,
      },
    ],
  },
  // {
  //   heading: "PHP-MYSQL",
  //   projects: [
  //     {
  //       heading: "Cricket Statistics",
  //       description:
  //         "I did it passionately.This app used pgadmin mysql database and php,html,css as front-end. Here admin just add data via front-end and database would updated accordingly.Then users can see a updated scorecard of match,updated profile of players etc.",
  //       video_link: "",
  //     },
  //     {
  //       heading: "IXL",
  //       description:
  //         "This one is an learning tool. It was developed with php and mysql database. Here students participate in quizes by solving questions. They can explore their dashboard. Teachers find out their performance and suggest or teach accordingly.",
  //       video_link: "",
  //     },
  //   ],
  // },
  // {
  //   heading: "NODEJS",
  //   projects: [
  //     {
  //       heading: "Backends of several apps",
  //       description:
  //         "I have developed a complete e-commerce app and a complete library app. The backend of these apps were developed in nodejs with mongodb database. Also I have worked in developing live chatbot which backend used socket connection. There was authentication feature and several others ie products/book info,carts info,user info, other necessary apis for admin.",
  //       video_link: "",
  //     },
  //   ],
  // },
];
const showcaseBestOnes = [
  showcaseProjects[1].projects[5],
  showcaseProjects[1].projects[4],
  showcaseProjects[1].projects[7],
  showcaseProjects[6].projects[1],
  showcaseProjects[1].projects[0],
];
showcaseProjects.unshift({
  heading: "Top Fives",
  projects: showcaseBestOnes,
});

export const showcaseData = Object.freeze(showcaseProjects);

export const messageToClient =
  "Send me your message about job or projects. Share your contact information so that i can reach to you. If i delay to reach, then please email me. Thank you!";
